import actions from './global/actions';
import mutations from './global/mutations';
import getters from './global/getters';
import PopFreeTrail from '../component/page/popbox/PopFreeTrail.vue';

// Global State
const state = {
  forceUpdateKey: 1,
  screenStatus: {
    flowBarFixed: false,
    rwdType: '',
  },
  popBox: {
    active: false,
    include: '',
  },
  popStartupBox: {
    active: false,
  },
  popCheckListBox: {
    active: false,
    detail: {},
  },
  popProgressBox: {
    active: false,
    feature: '',
  },
  popBloodUploadBox: {
    active: false,
    feature: '',
  },
  popTranslator: {
    active: false,
    detail: {},
  },
  popFreeTrail: {
    active: false,
  },
  popAnalysis: {
    active: false,
    detail: {},
  },
  popDietRecognize: {
    active: false,
    detail: {},
  },
  popShowTutorial: {
    active: false,
    include: '',
  },
  popYoutubePlayer: {
    active: false,
    link: '',
  },
  popCoursePlayer: {
    active: false,
    cid: '',
    uid: '',
  },
  popImgZoom: {
    active: false,
    src: '',
  },
  popQrCode: {
    active: false,
    link: '',
  },
  popTeamFeature: {
    active: false,
    features: '',
  },
  popControlQuestion: {
    active: false,
    qid: '',
    feature: '',
  },
  // popSendBless: {
  //   active: false,
  //   resumeId: '',
  // },
  // popDeleteResume: {
  //   active: false,
  //   userId: '',
  //   card: '',
  // },
  // popDeleteBless: {
  //   active: false,
  //   resumeId: '',
  // },
  // popDeleteReply: {
  //   active: false,
  //   aaId: '',
  //   qId: '',
  //   remindId: '',
  // },
  // popDeleteAsk: {
  //   active: false,
  //   qid: '',
  // },
  popDeleteTranslation: {
    active: false,
    id: null,
    forId: null,
  },
  popDeleteEpro: {
    active: false,
    id: '',
  },
  popDrugBox: {
    active: false,
    detail: {},
  },
  // popShopStuffBox: {
  //   active: false,
  //   detail: {},
  // },
  // popShopBundleBox: {
  //   active: false,
  //   detail: {},
  // },
  popAgreeList: {
    active: false,
    type: '',
    id: '',
  },
  popChatAdditional: {
    active: false,
    detail: {},
  },
  popReport: {
    active: false,
    detail: {},
  },
  // popRecordAdvise: {
  //   active: false,
  //   behavior: '',
  //   alert: [],
  // },
  popHelpFilter: {
    active: false,
    query: {},
  },
  popBusinessRequest: {
    active: false,
    purpose: '',
  },
  popLatestNews: {
    active: false,
    list: [],
  },
  popVendorProfile: {
    active: false,
    detail: {},
  },
  popEproRecordDetail: {
    active: false,
    recordId: null,
  },
  popChronicBloodDetail: {
    active: false,
    detail: null,
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
  strict: true,
};
